/**
 * ForcedSessionSigninPage
 *
 * A dedicated sign-in entry point that unconditionally selects the BFF session
 * auth path regardless of the current LD rollout percentage. Intended for QA
 * testers who need to exercise the session path at 0% rollout.
 *
 * Rendered at `/session-signin`. The `selectAuthPath` helper recognises this
 * pathname (step 2 in the decision order) and returns 'session', so
 * `handleEnterpriseHubSignin` will redirect to `/bff/login` rather than
 * running the PKCE flow.
 *
 * If the kill switch is engaged, `selectAuthPath` will override the forced
 * page and return 'pkce', rescuing testers off the forced path.
 */
import SigninPage from './SigninPage';

/**
 * Re-exports the regular SigninPage rendered under the `/session-signin` route.
 * `selectAuthPath` detects this pathname and returns 'session', causing
 * `AuthModule.signinViaBff()` to be called instead of the PKCE flow.
 */
export const ForcedSessionSigninPage = SigninPage;
export default ForcedSessionSigninPage;
